import styled from 'styled-components';
import Typography from '../../../Typography';

export const StyledActionButton = styled.button``;

export const StyledActionLabel = styled(Typography)`
    color: ${({ theme }) => theme.root.colors.primary.default};

    &:hover {
        color: ${({ theme }) => theme.root.colors.primary.hover};
    }
`;
